module.exports = __webpack_public_path__ + "img/dq-contrib-reply.cb3d3d38.png";